import { OktonSimpleCrudForm } from '@okton/platform-ui';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import BankAppPage from '../../../layout/BankAppPage';
import {
  useDepartamentos,
  useSaveDepartamento,
} from '../../../services/hooks/useCadastros';

const DepartamentoForm = () => {
  const history = useHistory();
  const { idDepartamento } = useParams<{ idDepartamento?: string }>();
  const edicao = !!idDepartamento;

  const { data: departamentos = [] } = useDepartamentos();
  const saveMutation = useSaveDepartamento();

  const [nome, setNome] = useState('');
  const [erro, setErro] = useState('');

  // A lista chega depois do primeiro render: sem isso a edição abriria vazia.
  useEffect(() => {
    const atual = departamentos.find(d => d.id_dpt === idDepartamento);
    if (atual) {
      setNome(atual.nome_dpt);
    }
  }, [departamentos, idDepartamento]);

  const salvar = async () => {
    if (!nome.trim()) {
      setErro('Informe o nome do Departamento.');
      return;
    }
    setErro('');
    try {
      await saveMutation.mutateAsync({ id: idDepartamento, nome: nome.trim() });
      history.push('/departamentos');
    } catch (err) {
      setErro(
        err instanceof Error ? err.message : 'Erro ao gravar o Departamento.',
      );
    }
  };

  return (
    <BankAppPage>
      <>
        <OktonSimpleCrudForm
          horizontalSpacing={0}
          title={edicao ? 'Editar Departamento' : 'Novo Departamento'}
          description="Classificação por departamento dos lançamentos"
          onCancel={() => history.push('/departamentos')}
          nameLabel="Nome"
          name={nome}
          onNameChange={setNome}
          maxName={60}
          error={erro}
          saving={saveMutation.isLoading}
          onSave={salvar}
        />
      </>
    </BankAppPage>
  );
};

export default DepartamentoForm;
